import React, { useMemo } from 'react';
import {
  StyledTable,
  MilestoneTableRow
} from 'modules';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';

export type MilestoneTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MilestoneTableProps) => {
  const params = useParams();

  const { data } = ds.useQuery(params.projectId ?? '');

  const headers: string[] = [
    'Title',
    'Description',
    'Start Date',
    'Duration',
    'End Date',
    'Associated Finishes'
  ];

  const rows = useMemo(() => {
    return data.map((node, i) => (
      <MilestoneTableRow.FC
        key={i}
        {...node}
      />
    ));
  }, [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />

  );
};
